export default "__VITE_ASSET__CMWECDk7__"